<template>
    <div class="thank-you">
        <div class="bg text-center">
            <img src="/images/promo/checkmark.svg" alt="" />
            <div class="thank-you__message">
                <h4>
                    {{ $t("promo.Thank you heading") }}
                </h4>
                <p>
                    {{ $t("promo.Thank you subheading") }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.thank-you {
    .bg {
        padding: 100px 0px;
        background: #f7f9fc;
        border-radius: 8px;
        margin-top: 32px;
        img {
            margin-bottom: 18px;
            display: inline-block;
        }
        @media (max-width: 768px) {
            padding: 40px 0px;
        }
    }
    &__message {
        h4 {
            font-style: normal;
            font-weight: 600;
            font-size: 28px;
            color: #141430;
        }
        p {
            font-style: normal;
            font-weight: normal;
            font-size: 16px;
            line-height: 28px;
            color: #141430;
        }
    }
}
</style>
